module.exports = __webpack_public_path__ + "static/media/campus-food-truck-catering-4.8b573650.jpeg";